import { render } from "./ChangeLayout.vue?vue&type=template&id=a5648bce&scoped=true"
import script from "./ChangeLayout.vue?vue&type=script&lang=js"
export * from "./ChangeLayout.vue?vue&type=script&lang=js"

import "./ChangeLayout.vue?vue&type=style&index=0&id=a5648bce&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5648bce"]])

export default __exports__